import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyCIfGpmYjGko0UQX6gGr5312QuLJf-igJg",
  authDomain: "salonmanager-fffab.firebaseapp.com",
  projectId: "salonmanager-fffab",
  storageBucket: "salonmanager-fffab.firebasestorage.app",
  messagingSenderId: "1052152454295",
  appId: "1:1052152454295:web:1e693329672f4f48fb9dd2"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
